import type { Column } from 'react-table';
import type { Statistics } from 'feature-components/reports/item-assessment-report';
import {
  NationalPercentageCol,
  PercentageCorrectCol,
  QuestionCol,
  QuestionDescriptionCol,
  QuestionTypeCol,
  ScaleDifficultyCol,
  getCategory
} from 'feature-components/reports/item-assessment-report/columns/common-columns';
import type { TestType } from 'services/assist-api/entities/test/tests';

export default function getJuniorAndSeniorScienceColumns(
  canHaveStyledQuestionType: boolean,
  showReferenceData: boolean,
  testType: TestType | undefined
): Column<Statistics>[] {
  return [
    {
      ...QuestionCol({
        canHaveStyledQuestionType,
        getText: (data) => `${getCategory(data.categories)?.name}`,
        testType
      }),
      sortType: (rowA, rowB) =>
        getCategory(rowA.original.categories).name > getCategory(rowB.original.categories).name
          ? 1
          : -1,
      width: 150
    },
    { ...QuestionTypeCol, width: 100 },
    QuestionDescriptionCol,
    ScaleDifficultyCol,
    PercentageCorrectCol(showReferenceData),
    showReferenceData && NationalPercentageCol
  ].filter(Boolean);
}
